import {Component, Mixins} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {CommitableDataSlidePanel} from "@/components/slide-panel";
import DateInput from "@/components/date-input";
import CavPocAccesPossible from "@/lib/models/cav-poc-acces-possible";
import ListDropdown from "@/components/list-dropdown";
import XInput from '@/components/x-input';
import XTextarea from '@/components/x-textarea';
import XRadio from '@/components/x-radio';
import DOMAIN_PUBLIC_PRIVE from "@/lib/constants/domain-public-prive";
import { LexPocAcces, LexPocModaliteAcces, LexPocEtatAcces } from '@/lib/models/gen-lexs';
import ComSystProjectFrance from '@/lib/models/com-syst-project-france';
import { notEmpty } from '@/lib/helpers';

@Component
export default class PanelPocAccesPossible extends Mixins<CommitableDataSlidePanel<CavPocAccesPossible>>(CommitableDataSlidePanel) {

  @Getter getLexique;
  @Getter getPositionableBeanCoord;

  get currentBeanCoord() {
    return this.getPositionableBeanCoord(this.data);
  }

  get beanCoordL93Rounded() {
    const nullCoords = {x: null, y: null};
    if (this.currentBeanCoord) {
      const beanL93 = this.currentBeanCoord.asL93();
      if (beanL93.isInFrance) {
        return {
          x: Math.round(Number(beanL93.x)),
          y: Math.round(Number(beanL93.y)),
        }
      }
    }
    return nullCoords;
  }

  async created() {
    this.create && (this.data = new CavPocAccesPossible());
    this.validators = [
      {fn: d => notEmpty(d.quand), message: "La date est requise"},
      {fn: d => notEmpty(d.nom), message: "Le nom est requis"},
      {fn: d => notEmpty(d.lexPocTypeAcces), message: "Le type d'accès est requis"},
      {fn: d => notEmpty(d.xouvrage) && notEmpty(d.youvrage) && notEmpty(d.lambertOuvrage), message: "Les coordonnées sont requises"},
      {fn: d => notEmpty(d.lexPocModaliteAcces), message: "Le champ « Modalité d'accès » est requis"},
      {fn: d => notEmpty(d.lexPocEtatAcces), message: "Le champ « Etat de l'accès » est requis"},
      {fn: d => notEmpty(d.domainePublicPrive), message: "Le champ « Domaine » est requis"}
    ];
  }

  mounted() {}

  renderHead() {
    return <span>Accès possibles</span>
  }

  renderBody() {
    if (!this.data) return null;
    return (
      <div class="basic">

        <div class="field">
          <label class="label is-small">Date (*)</label>
          <p class="control">
            <DateInput v-model={this.data.quand} />
          </p>
        </div>

        <div class="field">
          <label class="label is-small">Nom (*)</label>
          <div class="control">
            <XInput class="input is-small" v-model={this.data.nom}/>
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Type d'accès (*)</label>
          <div class="control">
            <ListDropdown
              class="basic"
              v-model={this.data.lexPocTypeAcces}
              data={this.getLexique(LexPocAcces)}
              prompt="-"
            />
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Coordonées</label>
          <div class="control">
            <ListDropdown
              class="basic"
              data={this.getLexique(ComSystProjectFrance)}
              v-model={this.data.lambertOuvrage}
              labelFn={v => v.systemeProjection}
              transform={v => v.codeSystProjection}
              prompt="-"
            />
          </div>
        </div>

        <div class="field is-grouped">
          <div class="control is-2">
            <label class="label is-small">X (*)</label>
            <XInput ofType="number" vModel={this.data.xouvrage} class="input is-small"/>
          </div>
          <div class="control is-2">
            <label class="label is-small">Y (*)</label>
            <XInput ofType="number" vModel={this.data.youvrage} class="input is-small"/>
          </div>
          <div class="control is-2">
            <label class="label is-small">X93</label>
            <input type="text" class="input is-small" readonly value={this.beanCoordL93Rounded.x}/>
          </div>
          <div class="control is-2">
            <label class="label is-small">Y93</label>
            <input type="text" class="input is-small" readonly value={this.beanCoordL93Rounded.y}/>
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Modalité d'accès (*)</label>
          <div class="control">
            <ListDropdown
              class="basic"
              v-model={this.data.lexPocModaliteAcces}
              data={this.getLexique(LexPocModaliteAcces)}
              prompt="-"
            />
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Etat de l'accès (*)</label>
          <div class="control">
            <ListDropdown
              class="basic"
              v-model={this.data.lexPocEtatAcces}
              data={this.getLexique(LexPocEtatAcces)}
              prompt="-"
            />
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Domaine (*)</label>
          <div class="control">
            <XRadio
              v-model={this.data.domainePublicPrive}
              data={DOMAIN_PUBLIC_PRIVE}
            />
          </div>
        </div>

        <div class="field">
          <label class="label is-small">Commentaire</label>
          <div class="control">
            <XTextarea class="textarea is-small" v-model={this.data.commentaire} />
          </div>
        </div>

      </div>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-40b34c0f/panel-access-possibles.tsx" });